class GrowShoppingCart { 
	constructor() {
		this.cart = [];
		this.deleteIcon = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.12695 3.76782H2.69835H15.2695" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M13.698 3.76779V14.7676C13.698 15.6354 12.9945 16.339 12.1266 16.339H4.26964C3.40178 16.339 2.69824 15.6354 2.69824 14.7676V3.76779M5.05534 3.76779V2.1964C5.05534 1.32854 5.75888 0.625 6.62674 0.625H9.76953C10.6374 0.625 11.3409 1.32854 11.3409 2.1964V3.76779" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>`
		this.init();
	}

	init() { 
		if (!document.querySelector('.grow--shopping-cart') && !document.querySelector('button[data-addtocart]')) return;
		this.form = document.querySelector('form[data-pdfform]');
		this.addEventListeners();
		this.cartElement = document.querySelector('.grow--shopping-cart');
		this.addToCartButton = document.querySelector('button[data-addtocart]');
		this.getLocalStorage()
		this.renderCart();
		console.log(this.cart)
	}
	
	addEventListeners() { 
		this.toggleCartSlide()
		if(!document.querySelector('button[data-addtocart]')) return
		const addToCartButton = document.querySelector('button[data-addtocart]');
		addToCartButton.addEventListener('click', el => this.addToCart(el));
		document.addEventListener('keyup', (e) => { 
			if (e.key === 'Escape') {
				this.closeModal(document.querySelector('.grow--modal'));
			}
		})
		this.handleSubmit()
	}

	toggleCart(visible) { 
		this.cartElement.classList.toggle('visible', visible);
	 }
	toggleCartSlide() {
		if (document.querySelector('.shoppingcart--button')) {
			 const toggleButton = document.querySelector('.shoppingcart--button');
			 toggleButton.addEventListener('click', (e) => { 
				 toggleButton.parentNode.classList.toggle('active');
			 })
		 }
	  }
	

	showModal(text) {
		const modal = document.createElement('div');
		modal.classList.add('grow--modal');
		const modalContent = document.createElement('div');
		modalContent.classList.add('grow--modal__content');

		const closeButton = document.createElement('button');
		closeButton.classList.add('grow--modal__close');
		closeButton.innerHTML = '&times;';
		closeButton.addEventListener('click', () => this.closeModal(modal));
		modalContent.innerHTML = `<p>${text}</p>`
		modalContent.appendChild(closeButton);
		modal.appendChild(modalContent);
		document.body.appendChild(modal);
	 }

	closeModal(el) {
		document.body.removeChild(el);
	}
	

	addToCart(el) {
		// check if item is already in cart
		const item = this.cart.find(item => item.title === el.target.dataset.title);

		console.log(item, this.cart)
		
		if (item) {
			this.showModal('Du hast diesen Trend bereits gewählt.');
			return;
		};

		if (this.cart.length >= 5) { 
			this.showModal('Du hast bereits 5 Trends gewählt.');
			this.addToCartButton.disabled = true;
			return;
		}

		this.cart.push({
			pdf: el.target.dataset.addtocart,
			title: el.target.dataset.title
		});
		this.setLocalStorage()
		this.renderCart()
	}

	displayCartCount() { 
		const cartCountElement = document.querySelectorAll('[data-pdfcount]');
		cartCountElement.forEach(element => element.innerHTML = this.cart.length)
	}

	removeFromCart(idx) { 
		document.querySelector('.grow--modal') ? this.closeModal(document.querySelector('.grow--modal')) : null;
		this.addToCartButton ? this.addToCartButton.disabled = false : null;
		this.cart.splice(idx, 1);
		this.renderCart();
		this.displayCartCount();
		this.setLocalStorage();
	}

	handleSubmit() { 
		this.form.addEventListener('submit', (e) => { 
			e.preventDefault();
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const emailValue = this.form.email.value
			const validEmail = emailRegex.test(emailValue);
			if (!validEmail) { 
				this.showModal('Bitte gib eine gültige E-Mail Adresse ein.');
				return;
			}
			const checkbox = this.form.consent;
			if (!checkbox.checked) {
				this.showModal('Bitte stimme den Datenschutzbestimmungen zu.');
				return;
			}
			
			this.submitFormData()


		})
	}

	submitFormData() { 
		// const formData = new FormData(this.form);
		// var myHeaders = new Headers();
		// myHeaders.append("Cookie", "PHPSESSID=59689d1b600cf2565c857d3509e60aea");

		var formdata = new FormData();
		formdata.append("token", this.form.token.value);
		formdata.append("campaign", this.form.campaign.value);
		formdata.append("email", this.form.email.value);
		formdata.append("data", this.form.data.value);
		formdata.append("count", this.form.data.value.split(',').length);
		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};

		fetch(this.form.action, requestOptions)
  			.then(response => response.json())
			.then(result => {
				this.showModal(result.message);
				this.cart = [];
				this.renderCart();
				this.displayCartCount();
				this.setLocalStorage();
			})
  			.catch(error => console.log('error', error));

		
	}

	setInputValue() { 
		// if (!document.querySelector('[data-trendorder]')) return;
		const input = document.querySelector('[data-trendorder]');
		// input.value is all names of this.cart
		input.value = this.cart.map(item => item.pdf).join(', ');
	}

	renderCart() { 
		const cartElementWrapper = document.querySelectorAll('[data-contents]');
		if (!cartElementWrapper) return;
		cartElementWrapper.forEach(wrapper => { 
			wrapper.innerHTML = '';
			this.cart.map((cart, idx) => { 
				const element = document.createElement('li');
				const deleteButton = document.createElement('button');
				deleteButton.innerHTML = this.deleteIcon;
				deleteButton.addEventListener('click', () => {
					this.removeFromCart(idx)
									
				})
				element.innerHTML = cart.title;
				element.appendChild(deleteButton);
				element.dataset.id = idx
				wrapper.appendChild(element);
			})
		})
		this.toggleCart(this.cart.length > 0)
		this.setInputValue();
		this.displayCartCount();
	}

	setLocalStorage() {
		localStorage.setItem( 'grow--shopping-cart', JSON.stringify( this.cart ) );
	 }
	getLocalStorage() {
		const cart = localStorage.getItem('grow--shopping-cart');
		if (cart) {
			this.cart = JSON.parse(cart);
		}
	 }

}

window.addEventListener('load', () => { 
	const growShoppingCart = new GrowShoppingCart();
})
